import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import { ClientDataStoreProperty } from './client-data-store-property.js'

@jsonClass('ClientDataStore')
export class ClientDataStore extends BusinessObject {
	@jsonArrayProperty(ClientDataStoreProperty)
	properties: ClientDataStoreProperty[] = []
	@jsonProperty(String)
	nameOnGlobalStore?: string

	constructor(init?: Partial<ClientDataStore>) {
		super()
		assignCommonProperties(this, init)
	}

	getNameOnGlobalStore() {
		const name =
			this.nameOnGlobalStore || this.boId.replace(/^./, (c) => c.toLowerCase())
		return name
	}
}
